module.exports = __webpack_public_path__ + "static/img/jiat-innovation.5f0c4b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/jiat-innovation.jpg
// module id = Po16
// module chunks = 0